import type { ReactNode } from 'react';

interface DataTableCountFooterProps {
  count: number;
  singular: string;
  plural?: string;
  countLabel?: ReactNode;
}

export function DataTableCountFooter({
  count,
  singular,
  plural,
  countLabel,
}: DataTableCountFooterProps) {
  const label = count === 1 ? singular : (plural ?? `${singular}s`);

  return (
    <div className="shrink-0 border-t px-4 py-2">
      <span className="text-xs text-muted-foreground">{countLabel ?? `${count} ${label}`}</span>
    </div>
  );
}
